import { Component, input, model, output } from '@angular/core';

@Component({
  selector: 'app-primeng-datepicker',
  templateUrl: './primeng-datepicker.component.html',
  styleUrls: ['./primeng-datepicker.component.scss'],
  standalone: false,
})
export class PrimengDatepickerComponent {
  value = model<Date | Date[] | null>(null);
  placeholder = input<string>('');
  disabled = input<boolean>(false);
  readonly = input<boolean>(false);
  selectionMode = input<'single' | 'multiple' | 'range'>('single');
  dateFormat = input<string>('dd/mm/yy');
  showTime = input<boolean>(false);
  showIcon = input<boolean>(true);
  iconDisplay = input<'button' | 'input'>('button');
  showButtonBar = input<boolean>(false);
  showWeek = input<boolean>(false);
  numberOfMonths = input<number>(1);
  view = input<'date' | 'month' | 'year'>('date');
  minDate = input<Date | null>(null);
  maxDate = input<Date | null>(null);
  appendTo = input<string>('body');
  inline = input<boolean>(false);
  touchUI = input<boolean>(false);
  styleClass = input<string>('');
  fluid = input<boolean>(false);
  id = input<string>('');
  label = input<string>('');
  showClear = input<boolean>(false);
  size = input<'small' | 'large' | undefined>(undefined);

  onSelect = output<Date>();
  onClear = output<void>();

  handleSelect(event: any) {
    this.value.set(event);
    this.onSelect.emit(event);
  }

  handleClear() {
    this.value.set(null);
    this.onClear.emit();
  }
}
